import { Injectable } from '@angular/core';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';
import { Observable } from 'rxjs';
import { WorkflowEmail } from './workflow-email';

@Injectable({
  providedIn: 'root',
})
export class WorkflowEmailService extends WorkflowDataService<WorkflowEmail> {
  protected override get apiEndpoint(): string {
    return '/email/template';
  }

  testEmail(email: WorkflowEmail): Observable<void> {
    return this.http.post<void>(`${this.baseUrl + this.apiEndpoint}/${email.identifier}/test`, {});
  }
}
